import Icon, { IconProps } from './Icon';

import TrashIcon from '../../../assets/icons/trash-04.svg?react';

const Trash: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <TrashIcon />
    </Icon>
  );
};

export default Trash;
